// extracted by mini-css-extract-plugin
export var alertCards = "_1-0";
export var card = "_1-1";
export var fade = "_1-2";
export var hidden = "_1-3";
export var progressBar = "_1-4";
export var roundtime = "_1-5";